import React, {useState} from 'react';
import {Container, Col, Row} from 'react-bootstrap';
import Logo from '../../../assets/png/logo_videos.png';
import Image1 from '../../../assets/png/video/kids_video1.png';
import Image2 from '../../../assets/png/video/kids_video2.png';
import Play from '../../../assets/png/video/tocar.png';
import Video1 from '../../../assets/videos/kids1.mp4';
import Video2 from '../../../assets/videos/kids2.mp4';
import Modallg from '../../ModalLg'; 
import './Videos.scss';

const Videos = () => {
    const [show, setShow] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    return (
        <>
        <Container className='conocenos' id='Conocenos'>
            <Row className='nombre'>
                <h1>
                    <span>K</span>
                    <span>i</span>
                    <span>d</span>
                    <span>s</span>
                    <span>C</span>
                    <span>l</span>
                    <span>u</span>
                    <span>b</span>
                    </h1>
            </Row>
            <Row className='presentacion'>
            <Col md={12} sm={12} xl={6} className='logo'>
            <img src={Logo} alt="" />
            </Col>
            <Col md={12} sm={12} xl={6} className='texto'>
            <Row>
                <div className="col">
                    <div className="small-img-row">
                        <div className="small-img">
                        <img src={Image1} alt="" />
                        <img src={Play} className='Play-btn' onClick={()=> setShowVideo(true)}/>
                        </div>
                        <p>¡Diversión sin limites!</p>
                    </div>
                    <div className="small-img-row">
                        <div className="small-img">
                        <img src={Image2} alt="" />
                        <img src={Play} className='Play-btn' onClick={()=> setShow(true)} />
                        </div>
                        <p>Los mejores eventos infantiles, solo en kids club.</p>
                    </div>
                </div>
            </Row>
            </Col> 
            </Row>
        </Container>
        <Modallg
        show={show}
        setShow={setShow}
        title={'Los mejores eventos infantiles, solo en kids club'}
        body={
            <div className="video__player">
            <video width="100%" controls autoPlay>
             <source src={Video1} type="video/mp4" />
            </video>
        </div>   
        }
        />
        <Modallg
        show={showVideo}
        setShow={setShowVideo}
        title={'¡Diversión sin limites!'}
        body={
            <div className="video__player">
            <video width="100%" controls autoPlay>
             <source src={Video2} type="video/mp4" />
            </video>
        </div>   
        }
        />
        </>
    )
}

export default Videos;